import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopyright } from "@fortawesome/pro-duotone-svg-icons";
import ReactHtmlParser from "react-html-parser";
import { Box, Typography } from "@mui/material";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";

const ArticleCopyRight = (
    {
        copyright
    }: {
        copyright: string
    }
) => {
    return (
        <Box component="section" role="contentinfo">
            <Typography
                component="h3"
                fontSize={'1.25rem'}
            >
                <SpanTypography mr={.25}>
                    <FontAwesomeIcon
                        icon={faCopyright}
                    />
                </SpanTypography>
                <SpanTypography fontSize={'1.25rem'}>
                    Copyright
                </SpanTypography>
            </Typography>
            <Typography
                color="text.secondary"
                fontSize={'.8rem'}
            >
                {
                    ReactHtmlParser(copyright)
                }
            </Typography>
        </Box>
    )
}

export default ArticleCopyRight;